import { render, staticRenderFns } from "./NewDialog.vue?vue&type=template&id=0f268e3c"
import script from "./NewDialog.vue?vue&type=script&lang=ts"
export * from "./NewDialog.vue?vue&type=script&lang=ts"
import style0 from "./NewDialog.vue?vue&type=style&index=0&id=0f268e3c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports